import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';

import { SideBarComponent } from './nav/sidebar-nav.component';
import {DxTreeViewModule} from 'devextreme-angular';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		RouterModule,
		NgxPermissionsModule,
		DxTreeViewModule,
	],
	declarations: [
		SideBarComponent,
	],
	exports: [
		SideBarComponent,
	]
})
export class CoreModule { }
